"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
const tslib_1 = require("tslib");
const lodash_1 = require("lodash");
const mobx_1 = require("mobx");
const mithril_1 = require("../../mithril");
const image_button_1 = require("../button/image.button");
const icons_1 = require("../icon/icons");
const mithril_component_1 = require("../mithril.component");
const theme_1 = require("../theme");
const theme_palette_1 = require("../theme.palette");
const CSS = {
    container: 'c-Carousel',
    constraint: 'c-Carousel__Constraint',
    controls: 'c-Carousel__Controls',
    track: 'c-Carousel__Track',
    center: 'c-Carousel__Center',
    image: 'c-Carousel__Image',
    dot: 'c-Carousel__Dot',
    highlighted: 'c-Carousel__Dot--highlighted',
};
const Style = {
    [CSS.container]: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    [CSS.controls]: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 1,
        pointerEvents: 'none',
    },
    [`${CSS.controls} a`]: {
        pointerEvents: 'all',
        backgroundColor: theme_1.DefaultTheme.background.mediumGrey,
        color: `rgb(${theme_palette_1.WHITE})`,
        '&:hover': {
            backgroundColor: theme_1.DefaultTheme.background.darkGrey,
        },
        '&:disabled': {
            backgroundColor: theme_1.DefaultTheme.background.mediumGrey,
            color: `rgb(${theme_palette_1.WHITE})`,
            opacity: '0.4',
        },
    },
    [CSS.constraint]: {
        overflow: 'hidden',
        position: 'relative',
        height: 'calc(100% - 18px)',
        paddingBottom: '6px',
    },
    [CSS.track]: {
        height: '100%',
        transition: '150ms ease',
        display: 'flex',
        flexWrap: 'nowrap',
    },
    [CSS.center]: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    [CSS.image]: {
        height: '100%',
    },
    [CSS.dot]: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        background: theme_1.DefaultTheme.background.lightGrey,
        cursor: 'pointer',
        border: 0,
        margin: '0 2px',
    },
    [CSS.highlighted]: {
        background: theme_1.DefaultTheme.background.mediumGrey,
    },
};
(0, theme_1.addStyles)(Style);
class Carousel extends mithril_component_1.IMithrilStateComponent {
    constructor({ index = 0, slides = [], showControls = true, onSlideChange }) {
        super();
        this.currentIndex = (0, lodash_1.clamp)(index, 0, slides.length - 1);
        this.slides = slides;
        this.showControls = showControls;
        this.onSlideChange = onSlideChange;
    }
    goTo(index) {
        var _a;
        this.currentIndex = (0, lodash_1.clamp)(index, 0, this.slides.length - 1);
        (_a = this.onSlideChange) === null || _a === void 0 ? void 0 : _a.call(this, this.currentIndex);
    }
    get scalarSlideWidth() {
        // avoid NaN from 0 denominator
        if (this.slides.length > 0) {
            return 100 / this.slides.length;
        }
        return 0;
    }
    get controls() {
        if (this.showControls) {
            return (0, mithril_1.m)('div', {
                className: CSS.controls,
            }, [
                image_button_1.ImageButton.view(icons_1.MaterialIcon.NAVIGATE_PREV, {
                    onclick: () => this.goTo(this.currentIndex - 1),
                    disabled: this.currentIndex === 0,
                }),
                image_button_1.ImageButton.view(icons_1.MaterialIcon.NAVIGATE_NEXT, {
                    onclick: () => this.goTo(this.currentIndex + 1),
                    disabled: this.currentIndex === this.slides.length - 1 || !this.slides.length,
                }),
            ]);
        }
        return null;
    }
    get dots() {
        return (0, mithril_1.m)('div', {
            className: CSS.center,
        }, this.slides.map((_, i) => (0, mithril_1.m)('button', {
            className: `${CSS.dot} ${i === this.currentIndex && CSS.highlighted}`,
            onclick: () => this.goTo(i),
        })));
    }
    get nodes() {
        return (0, mithril_1.m)('div', {
            className: CSS.container,
        }, [
            this.controls,
            (0, mithril_1.m)('div', {
                className: CSS.constraint,
            }, (0, mithril_1.m)('div', {
                className: CSS.track,
                style: {
                    width: `${100 * this.slides.length}%`,
                    transform: `translateX(-${this.currentIndex * this.scalarSlideWidth}%)`,
                },
            }, this.slides.map((slide) => (0, mithril_1.m)('div', {
                className: `${CSS.center} ${CSS.image}`,
            }, slide)))),
            this.dots,
        ]);
    }
}
exports.Carousel = Carousel;
tslib_1.__decorate([
    mobx_1.observable
], Carousel.prototype, "currentIndex", void 0);
tslib_1.__decorate([
    mobx_1.action
], Carousel.prototype, "goTo", null);
//# sourceMappingURL=carousel.component.js.map